import script from "./PortfolioFundsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioFundsModal.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioFundsModal.vue?vue&type=style&index=0&id=561e7054&lang=scss"

const __exports__ = script;

export default __exports__